import React, { useEffect, useState } from 'react'
import { approveOrRejectBillingSummaryByIdApi, approveOrRejectOrSubmitBillingByIdApi, approveOrRejectSiteBoqApi, getAllOrByIdOrDownloadBillingApi, getAllOrByIdOrDownloadFinalBillApi, } from '../../../utils/ApiEndpointFunctions';
import { useNavigate, useSearchParams, useLocation } from 'react-router-dom';
import Spinwheel from '../../../components/common/Spinwheel';
import { useUserContext } from '../../../context/userContext';
import toast from 'react-hot-toast';
import ConfirmationModal from '../../../components/modal/ConfirmationModal';
import Filter from '../../../components/modal/Filter';
import { useFormik } from 'formik';
import moment from 'moment/moment';
import ReactPaginate from 'react-paginate';
import { formatPrice, getLocalizationStatus } from '../../../utils/HelperFuncitons';
import StatusModal from '../../../components/modal/StatusModal';

export default function FinalBillTable(props) {
  const [bill, setBill] = useState([])
  const [loading, setLoading] = useState({ bill: true })
  const navigate = useNavigate();
  const { userDetails,langPreference} = useUserContext();
  const confirmSummaryModalId = "confirmSummaryModalID"
  const filterBillModalId = "filterBillModalID"
  const statusBillModalId = "statusBillModalId"
  const [selectBill, setSelectedBill] = useState({id:null,billNo:null,status:null});
  const limit = 10;
  const [page, setPage] = useState(0);
  const [searchParams, setSearchParams] = useSearchParams();
  const location = useLocation()
  const [totalCount, setTotalCount] = useState(null);
  const [confirmationMsg, setConfirmationMsg] = useState('')

  const getAllList = async (filterReset) => {
    setLoading({ ...loading, bill: true });
    console.log("filterFormik",filterFormik?.values);
    
    let filter = filterReset === "reset" ? ["", "", searchParams.get("tab"), "", "", ""] : [
       filterFormik.values?.number,
       filterFormik.values?.status,
       searchParams.get("tab"),
      `${filterFormik.values?.to ? new Date(filterFormik.values?.to).getTime() + "-" : ""}${filterFormik.values?.from ? new Date(filterFormik.values?.from).getTime() : ""}`,
      "","",
    ];
    try {
      const page = searchParams.get("page") || 1
      const res = await getAllOrByIdOrDownloadFinalBillApi(...filter, limit, page);
      if (res.status === 200) {
        setBill(res.data?.data?.billing);
        setTotalCount(res.data?.data?.totalCount);
        setPage(Math.ceil(res.data?.data?.totalCount / limit));
      }
    } catch (error) {
      console.log(error)
    }
    setLoading({ ...loading, bill: false });
  }

  const handlePageClick = (event) => {
    let currentPage = event.selected + 1;

    const newParams = new URLSearchParams(searchParams);
    newParams.set("page", currentPage);

    if (newParams.has("tab")) {
      newParams.set("tab", newParams.get("tab"));
      newParams.set("type", newParams.get("final-bill"));
    }

    setSearchParams(newParams);
  };


  const handleConfirmation = async () => {
    try {
      const res = await approveOrRejectBillingSummaryByIdApi({ id: selectBill.id,status:selectBill?.status })
      if (res.status === 200) {
         document.getElementById(confirmSummaryModalId).click()
         setConfirmationMsg(res?.data?.message || `Billing summary ${selectBill?.billNo || ""} is successfully ${selectBill?.status}.`)
         document.getElementById("statusModalBtn1").click()
      }
    } catch (error) {
      console.log(error)
      toast.error("something went wrong");
    }
  }


  const handleFilterPo = () => {
    if (searchParams.get('page') == 1) {
      getAllList()
    } else {
      setSearchParams({"tab": searchParams?.get("tab"),"type": searchParams?.get("type"),"page": 1, })
    }
  }

  const filterFormik = useFormik({
    initialValues: {
      Item: "",
      hsnCode: "",
      number: "",
      status: "",
      vendorName: "",
      to: "",
      from: "",
      itemId:""
    }
  })


  useEffect(() => {
    if(searchParams.get('page')){
      getAllList()
    }
  },[searchParams.get('page')])

  useEffect(() => {
    filterFormik.resetForm()
       getAllList("reset")
   },[searchParams.get('tab')])

  return (
    <>

      <div className="main-content">
        <div className="container-fluid">
          <div className="row">
            <div className="main-content">

              {props.type !== "dashboard" && <div className="dash-nav1">
                <div className="d-flex justify-content-between align-items-center">
                  <h3 className="mb-0 font-blue">{searchParams?.get('tab')=='client' ? (langPreference?.client || "Client"): (langPreference?.subContractor || "Sub-contractor")}</h3>
                  <div className='d-flex gap-2'>
                  {userDetails?.roleId?.permission?.includes("writeFinalBill") && <button onClick={() => { navigate(`/billing/summary/add?tab=${searchParams?.get('tab')}`); }} className="create-order mb-3">{langPreference?.create || "Create"}</button>}
                  </div>
                </div>
              </div>}
              <div className="d-flex justify-content-end align-items-end">
                <div className="d-flex align-items-center justify-content-end">
                  <div className="dropdown">
                    <button className="btn btn-dark me-2" type="button" disabled={!Object.values(filterFormik?.values).filter(Boolean).length} onClick={() => { filterFormik.resetForm(); getAllList("reset") }} >
                      {langPreference?.reset_filter || "Reset filter"}
                    </button>
                    <button className="btn filter  dropdown-toggle" type="button" data-bs-toggle="modal" data-bs-target={`#${filterBillModalId}`}  >
                      <i className="bi bi-funnel me-2"></i>{langPreference?.filter || "Filter"}
                    </button>
                  </div>
                </div>
              </div>
              {/* <!-- table --> */}
              <div className="table-responsive" style={{ overflowX: "inherit" }}>
                <table className="table d-table mt-4">
                  <thead>
                    <tr>
                      <th scope="col">{langPreference?.billing_number || "BILLING NUMBER"}</th>
                      <th scope="col">{langPreference?.item_counts || "ITEMS COUNT."}</th>
                      <th scope="col">{langPreference?.amount || "Amount"}</th>
                      <th scope="col">{langPreference?.ra_bill_no || "RA Bill No"}</th>
                      <th scope="col">{langPreference?.bill_date || "Bill Date"}</th>
                      <th scope="col">{langPreference?.status || "STATUS"}</th>
                      <th scope="col">{langPreference?.action || "ACTION"}</th>
                    </tr>
                  </thead>
                  {
                    loading.bill ?
                      <tbody >
                        <tr>
                          <td colSpan={12}>
                            <div className="d-flex justify-content-center">
                              <Spinwheel />
                            </div>
                          </td>
                        </tr>
                      </tbody> :
                     
                        <tbody>
                          {bill?.length > 0 ? bill?.map((ele, index) => {
                            return (
                              <tr key={index}>
                                <td>{ele?.billSummaryNumber}</td>
                                <td>{ele?.itemCount}</td>
                                <td>{ele?.netAmt ? formatPrice(ele?.netAmt) :""}</td>
                                <td>{ele?.raBillNo}</td>
                                <td>{moment(ele?.billDate).format("DD/MM/YYYY")}</td>
                                <td><button className={` cursor-text text-capitalize ${ele?.status?.toLowerCase() == "approved" ? "approve" : (ele?.status?.toLowerCase() == "rejected" ? "reject" : "sbm")} `}>{getLocalizationStatus(langPreference,ele?.status)}</button></td>
                                <td>
                                  <div className="d-flex justify-content-start align-items-center">
                                    <div>
                                      {userDetails?.roleId?.permission.includes("poReject") && ele?.status?.toLowerCase() !== "reject" && <button className="reject">Reject</button>}
                                    </div>
                                    <div>
                                      <div className="dropdown">
                                        <button className="dots dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false"><i className="bi bi-three-dots-vertical"></i></button>
                                        <ul className="dropdown-menu">
                                          {userDetails?.roleId?.permission.includes("readFinalBill") && <li className='dropdown-item' onClick={() => { navigate(`/billing/summary/view/${ele?._id}?tab=${searchParams?.get('tab')}`) }} >{langPreference?.view || "View"}</li>}
                                          {(((userDetails?.roleId?.permission.includes("updateFinalBill")) && ele?.status?.toLowerCase() != "approved" && ele?.status?.toLowerCase() != "rejected")) && <li className='dropdown-item' onClick={() => {navigate(`/billing/summary/update/${ele?._id}?tab=${searchParams?.get('tab')}`)}} >{langPreference?.edit || "Edit"}</li>}
                                          {userDetails?.roleId?.permission.includes("approveFinalBill") && ele?.status?.toLowerCase() == "submitted"  &&
                                            <li className='dropdown-item' data-bs-toggle="modal" data-bs-target={`#${confirmSummaryModalId}`} onClick={() => { setSelectedBill({id:ele?._id,billNo:ele?.billSummaryNumber,status:"approved"}) }} >{langPreference?.approve || "Approve"}</li>}
                                            {/* {userDetails?.roleId?.permission.includes("rejectFinalBill") && ele?.status?.toLowerCase() == "approved" &&
                                            <li className='dropdown-item' data-bs-toggle="modal" data-bs-target={`#${confirmSummaryModalId}`} onClick={() => { setSelectedBill({id:ele?._id,billNo:ele?.billNumber,status:"rejected"}) }} >{langPreference?.reject || "Reject"}</li>} */}
                                        </ul>
                                      </div>
                                    </div>
                                  </div>
                                </td>
                              </tr>)
                          }) : <tr className='text-center'>
                            <td colSpan="12">
                              <h1>{langPreference?.data_not_found || "Data Not Found"}</h1>
                            </td>
                          </tr>}
                        </tbody>}
                </table>
              </div>
              {totalCount > limit ? (
                <div className="d-flex justify-content-center">
                  <ReactPaginate
                   nextLabel={`${langPreference?.next_page || "Next"} >`}
                    onPageChange={handlePageClick}
                    pageRangeDisplayed={3}
                    marginPagesDisplayed={1}
                    pageCount={page}
                    previousLabel={`< ${langPreference?.previous_page || "Previous"}>`}
                    pageClassName="page-item"
                    pageLinkClassName="page-link"
                    previousClassName="page-item"
                    previousLinkClassName="page-link"
                    nextClassName="page-item"
                    nextLinkClassName="page-link"
                    breakLabel="..."
                    breakClassName="page-item"
                    breakLinkClassName="page-link"
                    containerClassName="pagination"
                    activeClassName={"active"}
                    forcePage={searchParams.get('page')? Number(searchParams.get('page'))-1 : 0}
                  />
                </div>
              ) : (
                ""
              )}
              <ConfirmationModal modalId={confirmSummaryModalId} handleConfirm={handleConfirmation} message={selectBill?.status=="approved" ? langPreference?.approve_confirmation ||  "approve" : langPreference?.confirm_reject || "reject"} />
              <Filter modalId={filterBillModalId} formik={filterFormik} clickHandler={handleFilterPo} filterType={"billing-summary"}/>
              <button className='d-none' id="statusModalBtn1" data-bs-toggle="modal" data-bs-target={`#${statusBillModalId}`}/>
              <StatusModal 
                modalId={statusBillModalId}
                message={confirmationMsg}
                handleClose={getAllList}
              />

            </div>
          </div>
        </div>
      </div>
    </>
  )
}
